@switch (iconName()) {
  @case ('contract_developer') {
    <lib-contract-developer-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('user') {
    <lib-user-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('tick_square') {
    <lib-tick-square-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('forbidden') {
    <lib-forbidden-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('clock') {
    <lib-clock-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('dollar_value') {
    <lib-dollar-value-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('arrow_right') {
    <lib-arrow-left-icon [iconClass]="'size-6 text-primary-500 rotate-180'" />
  }

  @case ('checked_list') {
    <lib-all-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('inbox') {
    <lib-inbox-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('multi_users') {
    <lib-multi-users-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('document') {
    <lib-document-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('edit_square') {
    <lib-edit-square-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('timer_start') {
    <lib-timer-start-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('task_view') {
    <lib-task-view-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('in_progress') {
    <lib-inprogress-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('tick') {
    <lib-tick-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('completed') {
    <lib-tick-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('close') {
    <lib-close-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('rejected') {
    <lib-close-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('remaining') {
    <lib-remaining-icon [iconClass]="'size-6 text-primary-500'" />
  }

  @case ('hold') {
    <lib-hold-icon
      [iconClass]="'size-6 text-primary-500 [&_path]:stroke-[1px]'" />
  }

  @default {
    <lib-info-icon [iconClass]="'size-6 text-primary-500'" />
  }
}
